<div class="filter-for-list">
  <h3 class="alarm-project-name">
    {{'PLANS_TITLE' | translate}}
  </h3>
  <button type="button" class="btn top-list-tools" placement="left"
          (click)="openUploadPlanModal()"
          [disabled]="showSpinner"
          [ngbTooltip]="'PLANS_ADD_TOOLTIP' | translate">
    <fa-icon [icon]="iconService.faUpload"></fa-icon>
    {{'PLANS_ADD' | translate}}
  </button>
  <app-project-sub-menu></app-project-sub-menu>
  <br clear="both"/>
  <br clear="both"/>
</div>


<app-progressbar *ngIf="showSpinner"></app-progressbar>


<div id="main" [ngStyle]="{opacity: showSpinner ? 0.5 : 1}">

  <div id="subMain_plan">
    <div id="planCont">
      <div id="planSubCont"
           #plan
           *ngIf="plans && plans[selectedPlanIndex]"
      >
        <img class="planLarge" [src]="plans[selectedPlanIndex].url">
        <div id="markersCont">
          <div *ngFor="let location of plans[selectedPlanIndex].location_plans"
               [ngStyle]="{top: location.pos_y + '%', left: location.pos_x + '%'}"
               class="marker label"
               cdkDrag
               cdkDragBoundary="#markersCont"
               (click)="toggleSelectedMarker(location.location_id, 'select')"
               (cdkDragStarted)="toggleSelectedMarker(location.location_id, 'select')"
               (cdkDragEnded)="updatePosition($event, location)"
               [ngbTooltip]="location.name">
            <img [src]="location.icon_url">
            <span>{{location?.device_type?.type !== 'pt_v5' ? location.note_litteral : ''}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="listCont" [ngClass]="{disabled: plans.length === 0}">
      <div *ngFor="let location of listLocations; let i = index"
           class="location flexCenter labelsCont"
           (click)="toggleSelectedMarker(location.id, location.selected ? 'unselect' : 'select')"
           [ngClass]="{locationSelected: location.selected, childMarker: location.parent, odd: (i % 2 === 0)}"
           style="cursor:pointer">
        <div class="labelCont">
          <div class="label">
            <img [src]="location.icon_url">
            <span>{{location?.device_type?.type !== 'pt_v5' ? location.note_litteral : ''}}</span>
          </div>
          <div>{{location.name}}</div>
        </div>
        <div>
          <fa-icon *ngIf="location.selected && location.location_plan_id"
                   (click)="deleteMarkerFromPlan(location.location_plan_id)"
                   class="closeButton"
                   [icon]="iconService.faTimes"
                   [matTooltip]="'TOOL_SEN_REMOVE_MAP' | translate"
                   matTooltipPosition="left">
          </fa-icon>
          <div *ngIf="!location.selected || (location.selected && !location.location_plan_id)">
            <fa-icon *ngIf="location.location_plan_id; else notLocated"
                     [icon]="iconService.faCheckCircle" style="color: #3eb6e9; font-size: 15px"></fa-icon>
            <ng-template #notLocated>
              <!--tooltip -->
              <fa-icon *ngIf="(!location.pos_x) || (!location.pos_y)"
                       (click)="addMarkerToPlan(location)"
                       [icon]="iconService.faPlusCircle"
                       [matTooltip]="'TOOL_SEN_ADD_MAP' | translate"
                       matTooltipPosition="left"
                       style="color: #337ab7; cursor: pointer; font-size: 15px"></fa-icon>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

  </div>


  <div class="filter-for-list">
    <h3 *ngIf="!showSpinner" class="alarm-project-name">
      {{'PLANS_GALLERY' | translate}}
    </h3>
    <br clear="both"/> <br clear="both"/>
  </div>


  <div id="subMain_gallery">
    <div id="planThumbnailCont">
      <div *ngFor="let plan of plans; let i = index;"
           class="planThumbnail"
           [ngClass]="selectedPlanIndex === i ? 'selectedPlanThumbnail' : ''">
        <img [src]="plan.url" (click)="displayPlan(i)">
        <div class="cancelButton">
          <fa-icon [icon]="iconService.faTrashAlt" (click)="deletePlan(plan.id)"
                   [matTooltip]="'TOOL_DELETE_PLAN' | translate"></fa-icon>
        </div>
        <div class="planNameCont">
          <input class="planNameInput" [value]="plan.name" #nameInput>
          <div class="planNameSubmit"
               (click)="changePlanName(plan.id, nameInput.value)">
            <fa-icon [icon]="iconService.faCheck"></fa-icon>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
